export enum ExpresionDinero {
   "",
   "%",
   "$",
}
